import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { isLogin } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

function TopBanner({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  return (
    <Container
      onClick={() => {
        if (!isLogin()) {
          modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
          return;
        }
        navigate('/quant');
      }}
    >
      <div style={{ width: '24px', height: '24px' }} />
      <Content>
        <Title>
          <span>돈 되는</span> 퀀트 전략 확인
        </Title>
        <Button>바로가기 {'>'}</Button>
      </Content>
      <img
        src="/assets/images/close/close-white.svg"
        alt=""
        width={24}
        height={24}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        style={{ cursor: 'pointer' }}
      />
    </Container>
  );
}

export default TopBanner;

const Container = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #090a09;
  cursor: pointer;
  padding: 8px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const Title = styled.div`
  font-family: 'SUIT';
  font-weight: 800;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0%;
  color: #ffffff;

  span {
    font-family: 'SUIT';
    font-weight: 800;
    font-size: 16px;
    line-height: 128%;
    letter-spacing: 0%;
    color: #00ff80;
  }
`;

const Button = styled.div`
  border-radius: 5px;
  padding: 3px 8px;
  background-color: #00ff80;

  font-family: SUIT;
  font-weight: 800;
  font-size: 11px;
  line-height: 128%;
  letter-spacing: 0%;
  color: #090a09;
`;
